// extracted by mini-css-extract-plugin
module.exports = {"loading":"widget-demo--loading--1jmdB","loadingMessage":"widget-demo--loadingMessage--3QFIm","logo":"widget-demo--logo--18GE6","spinner":"widget-demo--spinner--3kNnH"};